export * from "./image-config.view";
